import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthCode from './AuthCode';

import './styles/index.scss';

import getCode from '../../utils/getCode';
import { clearApiError } from '../../store/trail';
import { RootState } from '../../store';

import Button from '../Buttons/Button';

const CodeInput = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [code, setCode] = useState<string>('');
  const codeLength = 8;

  const apiError = useSelector((state: RootState) => state.trail.apiError);
  const loading = useSelector((state: RootState) => state.trail.loading);

  // getCode.ts dispatches distinct messages for "code genuinely doesn't
  // exist" vs. network/5xx failures (see utils/getCode.ts) — previously every
  // apiError rendered the same hardcoded "we couldn't find that code" text,
  // which is actively wrong/misleading for a transient network failure.
  // Branch on the dispatched string instead.
  const apiErrorMessage =
    typeof apiError === 'string'
      ? apiError.includes('was not found')
        ? "We couldn't find that code. Double-check it and try again."
        : apiError
      : apiError
        ? 'Something went wrong — please try again.'
        : null;

  const submit = (value: string) => {
    // On success getCode navigates away (this modal route unmounts); on failure
    // it dispatches apiError, which we surface inline below instead of silently
    // dropping the visitor back where they came from.
    dispatch(clearApiError());
    getCode(value, history);
  };

  const handleOnChange = (value: string) => {
    setCode(value.toUpperCase());
    if (apiError) {
      dispatch(clearApiError());
    }
    if (value.length === codeLength) {
      submit(value.toUpperCase());
    }
  };

  return (
    <div className="CodeInput">
      <h2>Enter Code:</h2>
      <br />
      <AuthCode
        autoFocus
        onChange={handleOnChange}
        inputClassName="CodeInput_input"
        containerClassName="CodeInput_container"
        length={codeLength}
      />
      {!!apiErrorMessage && (
        <p role="alert" className="CodeInput_error">
          {apiErrorMessage}
        </p>
      )}
      <Button
        label={loading ? 'Checking…' : 'Go'}
        color="primary"
        size="large"
        onClick={() => submit(code)}
        disabled={code.length < codeLength || loading}
      />
    </div>
  );
};

export default CodeInput;
